<template>
  <div id="app">
    <Header />
    <router-view/>
  </div>
</template>

<script>
  import Header from './components/layout/Header.vue';
  export default {
    name: 'App',
    components: {
      Header
    }
  }
</script>

<style>
  	@font-face {
    	font-family: "BrownLLWeb-Regular";
  		src: url("assets/fonts/BrownLLWeb-Regular.woff") format("woff");
	}
	@font-face {
    	font-family: "BrownLLWeb-Bold";
  		src: url("assets/fonts/BrownLLWeb-Bold.woff") format("woff");
	}

	#app {
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: stretch;
	}

	* {
		box-sizing: border-box;
		margin: 0;
		padding: 0;
	}

	html, body {
		height: 100%;
		margin: 0;
	}

	body {
		font-family: "BrownLLWeb-Regular", Helvetica, sans-serif;
		font-size: 15px;
		line-height: 1.4;
		color: black;
	}

	h1 {
		font-family: "BrownLLWeb-Bold", Helvetica, sans-serif;
		font-weight: bold;
		font-size: 25px;
	}

	h2 {
		font-family: "BrownLLWeb-Regular", Helvetica, sans-serif;
		font-weight: normal;
		font-size: 25px;
	}

	h3 {
		font-family: "BrownLLWeb-Regular", Helvetica, sans-serif;
		font-weight: normal;
		font-size: 20px;
	}

	img, video {
		background-color: #333;
	}

	.checkerboard {
		background-image: linear-gradient(45deg, #808080 25%, transparent 25%), 
			linear-gradient(-45deg, #808080 25%, transparent 25%), 
			linear-gradient(45deg, transparent 75%, #808080 75%), 
			linear-gradient(-45deg, transparent 75%, #808080 75%);
  		background-size: 20px 20px;
  		background-position: 0 0, 0 10px, 10px -10px, -10px 0px;
	}

	.flexContainer {
		display: flex;
  		flex-wrap: nowrap;
		flex-grow: 1;
	}

	.flexContainer .navBox {
		display: flex;
		flex-direction: column;
		margin-top: 20px;
		padding-bottom: 40px;
		border-left: black solid 1px;
		border-top: black solid 1px;
		border-bottom: black solid 1px;
		position: relative;
	}

	.flexContainer .contentBoxLeft {
		display: flex;
		flex-direction: column;
		flex: 1 0 0;
		justify-content: flex-start;
		margin-top: 20px;
		border-left: black solid 1px;
		border-top: black solid 1px;
		border-bottom: black solid 1px;
	}

	.flexContainer .contentBoxRight {
		display: flex;
		flex-direction: column;
		flex: 1 0 0;
		justify-content: flex-start;
		margin-top: 20px;
		border: black solid 1px;
	}

 	.flexContainer .contentBox {
	  	display: flex;
		flex-direction: row;
		flex: 1 0 0;
		justify-content: flex-start;
		min-width: 280px;
		margin-top: 20px;
		padding: 20px;
		border: black solid 1px;
	}

	.navBox .navItem {
		font-family: "BrownLLWeb-Regular", Helvetica, sans-serif;
		font-weight: normal;
		font-size: 20px;
		padding: 6px 70px 6px 40px;
	}

	.navBox .navItem:hover {
		font-family: "BrownLLWeb-Bold", Helvetica, sans-serif;
		font-weight: bold;
		cursor: pointer;
	}

	.navBox .navItemActive {
		font-family: "BrownLLWeb-Bold", Helvetica, sans-serif;
		font-weight: bold;
		border-top: black solid 1px;
		border-bottom: black solid 1px;
		padding-left: 20px;
	}

  	.button, .buttonDisabled {
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 10px 15px 10px 15px;
		margin: 25px 10px 10px 10px;
		font-family: "BrownLLWeb-Regular", Helvetica, sans-serif;
		font-size: 20px;
  	}

	.button {
		color: black;
		background-color: white;
		border: solid 1px black;
		cursor: pointer;
	}

  	.button:hover {
    	color: white;
		background-color: black;
  	}

    .buttonDisabled {
		color: #999999;
		background-color: #efefef;
        border: 1px solid #dddddd;
        cursor: default;
    }
	
	.buttonDisabled:hover {
    	color: #999999;
		background-color: #efefef;
  	}

	.buttonGroup {
        display: flex;
        align-items: center;
        justify-content: center;
    }

	.saveCancelButtons {
        width: 100%;
        display: flex;
        position: absolute;
        bottom: 20px;
        align-items: center;
        justify-content: center;
    }

    .saveCancelButtons .button, .buttonGroup .button {
        margin-left: 10px;
		margin-right: 10px;
    }
	
	.overlayFullscreen {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 99;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .overlayContainer {
        background-color: white;
        /*border: solid 1px black;*/
        width: 90%;
        height: 80%;
        position: relative;
    }

	.deleteDialog {
		cursor: default;
		background: rgba(0, 0, 0, 0.8);
		color:white;
		position: absolute;
		top: 0px;
		left: 0px;
		width: 100%;
		height: 100%;
		padding: 25px;
	}
	
    .deleteDialog .button:hover {
        border: 1px solid white;
    }
	
	.deleteText {
		font-size: 24px;
		text-align: center;
	}
	/*
    ::-webkit-scrollbar {
      width: 15px;
    }
    ::-webkit-scrollbar-track {
      background: #fff;
      border: 1px solid black;
    }
    ::-webkit-scrollbar-thumb {
      background: #000;
    }
    ::-webkit-scrollbar-thumb:hover {
      background: #333;
    }
	*/
</style>
